const getters = {
  loading: state => state.config.loading,
  pageLoading: state => state.config.pageLoading,
  times: state => state.config.times,
  themeList: state => state.article.themeList,
  currentThemeId: state => state.article.currentThemeId,
  editArticleId: state => state.article.editArticleId,
  cropWidth: state => state.article.cropWidth,
  cropHeight: state => state.article.cropHeight,
  user_name: state => state.user.user_name,
  user_gender: state => state.user.user_gender,
  school_name: state => state.school.school_name,
  school_logo: state => state.school.school_logo
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js